// extracted by mini-css-extract-plugin
module.exports = {"root":"HeldTicketsLink_root___0VNw","link":"HeldTicketsLink_link__75tHc"};